export enum BatchTypeEnum {
  CreateVisitPlan = "CreateVisitPlan",
  SyncVisitPlanAccounts = "SyncVisitPlanAccounts",
  PublishVisitSchedule = "PublishVisitSchedule",
  DispatchVisitSchedule = "DispatchVisitSchedule",
  ScanDraftJobChanges = "ScanDraftJobChanges",
  ApplyDraftJobChanges = "ApplyDraftJobChanges",
  UpdateDeliveryData = "UpdateDeliveryData",
  RecalculateVisitPlan = "RecalculateVisitPlan",
  ExportTimeCardsPayroll = "ExportTimeCardsPayroll"
}
